module.exports = __webpack_public_path__ + "static/media/trash.8f76622f.svg";